module.exports = __webpack_public_path__ + "img/image41.95be47d1.png";